/**
 * 轻量 Toast：自实现的非阻塞提示，避免引入 UI 库
 */

type ToastType = 'info' | 'success' | 'warning' | 'error'

interface ToastOptions {
  message: string
  type?: ToastType
  duration?: number
}

let container: HTMLDivElement | null = null

function ensureContainer() {
  if (container) return container
  container = document.createElement('div')
  container.className = 'pointer-events-none fixed top-6 left-1/2 z-[9999] flex -translate-x-1/2 flex-col gap-2'
  document.body.appendChild(container)
  return container
}

const COLOR_MAP: Record<ToastType, string> = {
  info: 'bg-slate-700/90 border-slate-500/30',
  success: 'bg-emerald-700/90 border-emerald-500/30',
  warning: 'bg-amber-700/90 border-amber-500/30',
  error: 'bg-rose-700/90 border-rose-500/30',
}

export function toast(opts: ToastOptions | string) {
  const options: ToastOptions = typeof opts === 'string' ? { message: opts } : opts
  const { message, type = 'info', duration = 2500 } = options
  const el = document.createElement('div')
  el.className = `pointer-events-auto animate-fade-in rounded-lg border px-4 py-2 text-sm text-white shadow-lg backdrop-blur ${COLOR_MAP[type]}`
  el.textContent = message
  const c = ensureContainer()
  c.appendChild(el)
  setTimeout(() => {
    el.style.transition = 'opacity 0.3s'
    el.style.opacity = '0'
    setTimeout(() => el.remove(), 300)
  }, duration)
}

toast.success = (msg: string) => toast({ message: msg, type: 'success' })
toast.error = (msg: string) => toast({ message: msg, type: 'error' })
toast.warning = (msg: string) => toast({ message: msg, type: 'warning' })
toast.info = (msg: string) => toast({ message: msg, type: 'info' })

export default toast